<template>
  <el-drawer
    id="crm-redeem-code-drawer"
    :visible.sync="isOpen"
    direction="btt"
    :show-close="false"
    :destroy-on-close="true"
    class="drawer-dialog"
    :before-close="handleClose"
  >
    <template>
      <el-row class="crm-site">
        <el-col>
          <h2 class="crm-confirm-text">{{ $t('components.elements.confirm') }}</h2>
          <label class="crm-confirm-text" v-if="!promotionDetail.isPrivilege">
            {{ $t('components.elements.confirm-redemption',{ point: numberWithCommas(promotion.point), unit: (promotion.point >= -1 && promotion.point &lt;= 1) ? $t('components.elements.point') : $t('components.elements.points') }) }}
            <span style="font-weight: 500;">{{`${branchInfo.branchName} `}}</span>
            {{$t('components.elements.confirm-redemption-1')}}
          </label>
        </el-col>
        <el-col class="crm-entry-action">
          <el-row class="d-flex-between">
            <el-col :span="11" style="padding-left: 5px">
              <el-button type="crm-foodstory-default" @click="handleClose">
                {{ $t('components.elements.cancel') }}
              </el-button>
            </el-col>
            <el-col :span="11">
              <el-button type="crm-foodstory" @click="handleConfirm">
                {{ $t('components.elements.ok') }}
              </el-button>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </template>
  </el-drawer>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import mixins from "@/helper/mixins";
import GATracking from "@/helper/GATrackingMixins";
import lineAPI from "@api/line-api";

export default {
  mixins: [mixins, GATracking],
  props: {
    isOpen: {
      type: Boolean,
    },
    promotion: {
      type: Object,
      default: () => {},
    },
    closeDrawer: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    handleClose() {
      this.trackActivity(8, 'RedeemCRMPromotion');
      this.closeDrawer();
    },
    handleConfirm() {
      this.trackActivity(7, 'RedeemCRMPromotion');
      
      if( this.promotionDetail.proAddFriend){
        lineAPI.seveDateAddLineFriend({ restaurantUUID : this.restaurantUUID})
      }

      if(this.promotionDetail.rewardsPoint == null || this.promotionDetail.rewardsPoint == 0 ){
        this.redeemPromotion({
          promotionRefKey: this.promotionDetail.promotionRefKey,
          branchUUID: this.branchInfo.branchUUID,
        });
      }
      else{
        this.earnPointsAddFriend({
          promotionRefKey: this.promotionDetail.promotionRefKey,
          branchUUID: this.branchInfo.branchUUID,
        });
      }
      
    },
    ...mapActions({
      redeemPromotion: "promotion/redeemPromotion",
      earnPointsAddFriend: "promotion/earnPointsAddFriend"
    }),
  },
  computed: {
    ...mapGetters({
      branchInfo: "branch/branchInfo",
      promotionDetail: "promotion/promotionDetail",
      restaurantUUID: "restaurant/restaurantUUID",
    }),
  },
};
</script>
<style scoped>
.d-flex-between {
  display: flex;
  justify-content: space-between;
}
.crm-site {
  padding: 16px;
  font-size: 18px;
}

.crm-site h2 {
  font-size: 24px;
  font-weight: 500;
}

.crm-site label {
  font-size: 20px;
  font-weight: lighter;
}

.crm-site .crm-entry-action {
  padding: 16px 8px;
}

.crm-site button {
  width: 100%;
  height: 45px;
  font-size: 300;
}

.crm-confirm-text {
  margin-left: 8px;
  margin-top: 8px;
  margin-bottom: 8px;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: keep-all;
}
</style>